import PropTypes from 'prop-types';

import { useContext } from 'react';

import MaterialsCaptureContext from '../../context/MaterialsCaptureContext';

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

const UltracentrifugationForm = ({ data }) => {
  const { handleInputChange, formErrors } = useContext(MaterialsCaptureContext);

  return(
    <Grid container spacing={1} mt={1}>
      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Ultracentrifuge - Filter Type"
          name={`ultracentrifuge_filter_type-${data?.index}`}
          value={data?.ultracentrifuge_filter_type}
          onChange={e => 
            handleInputChange(
              e, data?.index, 'ultracentrifuge_filter_type', e.target.value
            )
          }
          helperText={formErrors[`ultracentrifuge_filter_type-${data?.index}`]}
          error={`ultracentrifuge_filter_type-${data?.index}` in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Membrane type"
          name={`membrane_type-${data?.index}`}
          value={data?.membrane_type}
          onChange={e => 
            handleInputChange(e, data?.index, 'membrane_type', e.target.value)
          }
          helperText={formErrors[`membrane_type-${data?.index}`]}
          error={`membrane_type-${data?.index}` in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Starting volume (mL)"
          name={`starting_volume-${data?.index}`}
          value={data?.starting_volume}
          onChange={e => 
            handleInputChange(e, data?.index, 'starting_volume', e.target.value)
          }
          helperText={formErrors[`starting_volume-${data?.index}`]}
          error={`starting_volume-${data?.index}` in formErrors}
          type='number'
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Target volume (mL)"
          name={`target_volume-${data?.index}`}
          value={data?.target_volume}
          onChange={e => 
            handleInputChange(e, data?.index, 'target_volume', e.target.value)
          }
          helperText={formErrors[`target_volume-${data?.index}`]}
          error={`target_volume-${data?.index}` in formErrors}
          type='number'
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Speed (RCF)"
          name={`speed-${data?.index}`}
          value={data?.speed}
          onChange={e => 
            handleInputChange(e, data?.index, 'speed', e.target.value)
          }
          helperText={formErrors[`speed-${data?.index}`]}
          error={`speed-${data?.index}` in formErrors}
          type='number'
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Tempertaure °C"
          name={`tempertaure-${data?.index}`}
          value={data?.tempertaure}
          onChange={e => 
            handleInputChange(e, data?.index, 'tempertaure', e.target.value)
          }
          helperText={formErrors[`tempertaure-${data?.index}`]}
          error={`tempertaure-${data?.index}` in formErrors}
          type='number'
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Time (minutes)"
          name={`time-${data?.index}`}
          value={data?.time}
          onChange={e => 
            handleInputChange(e, data?.index, 'time', e.target.value)
          }
          helperText={formErrors[`time-${data?.index}`]}
          error={`time-${data?.index}` in formErrors}
          type='number'
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Final concention (mg/ml)"
          name={`final_concention-${data?.index}`}
          value={data?.final_concention}
          onChange={e => 
            handleInputChange(e, data?.index, 'final_concention', e.target.value)
          }
          helperText={formErrors[`final_concention-${data?.index}`]}
          error={`final_concention-${data?.index}` in formErrors}
          type='number'
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

UltracentrifugationForm.propTypes = {
  data: PropTypes.object.isRequired,
};

export default UltracentrifugationForm;